import axios from 'axios';
import config from '../../config'; // Ajusta la ruta según tu estructura

const baseUrl = config.baseUrl;
//const baseUrl = 'http://localhost:5000';

// Función para obtener datos del mapa de un departamento específico

const replaceNullWithDash = (value) => (value === null || value === undefined) ? '-' : value;

const getMapDepartment = async (departmentId) => {

    try {
        const response = await axios.get(`${baseUrl}/api/mapDepartment/${departmentId}`);
        const data = response.data.data; // Ajusta según el formato de respuesta

        const processedData = data.map(muni => {
            const hombres = muni.numero_hombres != null ? Number(muni.numero_hombres) : 0;
            const mujeres = muni.numero_mujeres != null ? Number(muni.numero_mujeres) : 0;
            const total = hombres + mujeres;

            const pctHombres = total > 0 ? Math.round((hombres / total) * 100) : 0;
            const pctMujeres = total > 0 ? Math.round((mujeres / total) * 100) : 0;

            return {
                id: muni.codigoFusion,                 // ID FusionCharts
                value: total || 0,                     // valor numérico
                label: muni.municipio,
                shortLabel: muni.codigoFusion,
                nombreDepto: muni.departamento,
                color: '#4275af',
                hoverBorderThickness: '2',

                toolText: `
                <div style="font-family: Arial, sans-serif; font-size: 14px;">
                  <table style="width:100%; border-collapse:collapse;">
                    <tbody>
          
                      <!-- TÍTULO -->
                      <tr>
                        <td colspan="2"
                            style="font-weight:bold;font-size:16px;padding-bottom:8px;border-bottom:2px solid #d0d0d0;">
                          ${muni.municipio} | ${muni.departamento}
                        </td>
                      </tr>
          
                      <!-- PROYECTOS -->
                      <tr>
                        <td colspan="2" style="padding-top:8px;">
                          <strong>Proyectos (${muni.total_proyectos}):</strong>
                          <ul style="margin:4px 0 0 15px;">
                            ${muni.listaproyectos
                        ? muni.listaproyectos
                            .split('</li><li>')
                            .map(p => `<li>${p.replace(/<\/?li>/g, '')}</li>`)
                            .join('')
                        : '<li>-</li>'
                    }
                          </ul>
                        </td>
                      </tr>
          
                      <tr>
                        <td colspan="2" style="border-top:2px solid #d0d0d0;padding-top:8px;"></td>
                      </tr>
          
                      <!-- PARTICIPANTES -->
                      <tr>
                        <td colspan="2"><strong>Participantes</strong></td>
                      </tr>
          
                      <tr>
                        <td>
                          <strong>Hombres:</strong>
                          ${hombres.toLocaleString('es-CO')}
                          (${pctHombres}%)
                        </td>
                        </tr>
                        <tr>
                        <td>
                          <strong>Mujeres:</strong>
                          ${mujeres.toLocaleString('es-CO')}
                          (${pctMujeres}%)
                        </td>
                      </tr>
          
                      <tr>
                        <td colspan="2" style="padding-top:6px;">
                          <strong>Total Familias:</strong>
                          ${total.toLocaleString('es-CO')}
                        </td>
                      </tr>
          
                    </tbody>
                  </table>
                </div>
              `,

                link: muni.link || 'https://472.bodecom.com/',
            };
        });


        return {
            status: response.status,
            data: {
                data: processedData // Asegúrate de que este campo se corresponda con lo esperado por FusionCharts
            }
        };
    } catch (error) {
        console.error(`Error al obtener datos del mapa del departamento ${departmentId}:`, error);
        throw error;
    }
};

export { getMapDepartment };
